import React, { FC } from "react";

import {
  ColorSubtitleText,
  IgTooltip,
  IgTypography,
} from "@intelligems/ig-theme";
import { capitalizeFirstLetter } from "@intelligems/ig-utils";
import { Person } from "@mui/icons-material";
import { CircularProgress, Grid } from "@mui/material";

import { PersonalizationOrderMetricIcon } from "../../../../images/Icons/Offer/PersonalizationOrderMetricIcon";
import { PriceTestIconFilled } from "../../../../images/Icons/PriceTest/PriceTestIconFilled";

interface PersonalizationOverviewMetricsProps {
  formattedData: {
    visitors: string;
    orders: string;
    revenue: string;
  };
  isDataLoading: boolean;
}
const iconKeyMapping = {
  visitors: <Person sx={{ fontSize: "14px", color: ColorSubtitleText }} />,
  orders: (
    <PersonalizationOrderMetricIcon
      sx={{ fontSize: "14px", color: ColorSubtitleText }}
    />
  ),
  revenue: (
    <PriceTestIconFilled
      height={"14px"}
      width={"14px"}
      fill={ColorSubtitleText}
    />
  ),
};
export const PersonalizationOverviewMetrics = ({
  formattedData,
  isDataLoading,
}: PersonalizationOverviewMetricsProps) => {
  return (
    <Grid
      item
      container
      justifyContent={"flex-end"}
      alignItems={"center"}
      columnSpacing={1}
    >
      {Object.keys(formattedData).map((key, index) => (
        <Grid item key={index}>
          <IgTooltip title={capitalizeFirstLetter(key)}>
            <Grid item container alignItems={"center"}>
              {iconKeyMapping[key]}
              <IgTypography
                sx={{
                  fontSize: "14px",
                  color: ColorSubtitleText,
                  marginLeft: "5px",
                }}
              >
                {isDataLoading ? (
                  <CircularProgress size={10} />
                ) : (
                  formattedData[key]
                )}
              </IgTypography>
            </Grid>
          </IgTooltip>
        </Grid>
      ))}
    </Grid>
  );
};
